import { render, staticRenderFns } from "./TabOxygenConcentrationFAQ.vue?vue&type=template&id=4d938597&scoped=true"
import script from "./TabOxygenConcentrationFAQ.vue?vue&type=script&lang=js"
export * from "./TabOxygenConcentrationFAQ.vue?vue&type=script&lang=js"
import style0 from "./TabOxygenConcentrationFAQ.vue?vue&type=style&index=0&id=4d938597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d938597",
  null
  
)

export default component.exports